import { Flex, Spinner } from '@chakra-ui/react';
import React from 'react';
import { loaderStyles } from '../constants';

const Loader = () => {
  return (
    <Flex {...loaderStyles}>
      <Spinner size={'xl'} />
    </Flex>
  );
};

export default Loader;
